import { axiosInstance } from "contexts/axiosApiInstance";

export interface CatalogModelRow {
  model_id: string;
  name: string;
  color: string | null;
  icon: number | null;
  /// Present while the model is in the Trash: when it is purged (epoch s).
  scheduled_deletion_date: number | null;
}

export interface CatalogModels {
  /// Trash, restore and delete forever — the publish role.
  can_delete: boolean;
  models: CatalogModelRow[];
}

export const fetchCatalogModels = async (): Promise<CatalogModels> => {
  const { data } = await axiosInstance.get<CatalogModels>(
    "/action/catalog/models",
  );
  return data;
};
